export default class MarketplaceProductsShow {

  constructor() {}

  render() {
    let currentImageIndex = 0;
    let productImages = [];
    const modalImage = document.getElementById('modalImage');
    const currentImageSpan = document.getElementById('currentImage');
    const prevButton = document.getElementById('prevImage');
    const nextButton = document.getElementById('nextImage');
    
    // Get product images from data attribute and parse as array
    const imageModal = document.getElementById('imageModal');
    if (imageModal) {
      const imagesData = imageModal.getAttribute('data-product-images');
      if (imagesData) {
        productImages = imagesData.split(', ').filter(img => img.trim() !== '');
      }
    }
    
    function updateImage() {
      if (productImages.length > 0 && modalImage && currentImageSpan) {
        modalImage.src = productImages[currentImageIndex];
        currentImageSpan.textContent = currentImageIndex + 1;
        
        // Hide/show arrows based on position
        if (prevButton) {
          prevButton.style.display = currentImageIndex === 0 ? 'none' : 'block';
        }
        if (nextButton) {
          nextButton.style.display = currentImageIndex === productImages.length - 1 ? 'none' : 'block';
        }
      }
    }
    
    // Modal show event
    $('#imageModal').on('show.bs.modal', function(event) {
      const button = $(event.relatedTarget);
      const imageIndex = button.data('image-index');
      currentImageIndex = parseInt(imageIndex) || 0;
      
      // Ensure index is within bounds
      if (currentImageIndex >= productImages.length) {
        currentImageIndex = 0;
      }
      
      updateImage();
    });
    
    // Previous image
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentImageIndex > 0) {
          currentImageIndex--;
          updateImage();
        }
      });
    }
    
    // Next image
    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentImageIndex < productImages.length - 1) {
          currentImageIndex++;
          updateImage();
        }
      });
    }
    
    // Keyboard navigation
    $(document).on('keydown', function(e) {
      if ($('#imageModal').hasClass('show')) {
        if (e.key === 'ArrowLeft' && currentImageIndex > 0) {
          currentImageIndex--;
          updateImage();
        } else if (e.key === 'ArrowRight' && currentImageIndex < productImages.length - 1) {
          currentImageIndex++;
          updateImage();
        }
      }
    });

  }

}